<template>
  <form-field label="Credit Card Details">
    <div id="card-element" class="card_input">
      <!-- A Stripe Element will be inserted here. -->
    </div>
  </form-field>
</template>

<script>
export default {
  name: "AppStripeElement",
  data() {
    return {
      // eslint-disable-next-line no-undef
      Stripe: Stripe(process.env.MIX_STRIPE_API_KEY),
      StripeCard: null,
      StripeErrors: null,
      stripeStyle: {
        base: {
          // Add your base input styles here. For example:
          fontSize: '16px',
          fontFamily: 'inherit',
          color: "#363636",
        }
      },
    }
  },
  mounted() {
    this.StripeCard = this.Stripe.elements().create('card', {style: this.stripeStyle});
    this.StripeCard.mount('#card-element');
    this.StripeCard.addEventListener('change', (event) => {
      if (event.value.postalCode) {
        this.$emit('postalChanged', event.value.postalCode);
      }

      if (event.error) {
        this.StripeErrors = event.error.message;
        this.$emit('error');
      } else {
        this.StripeErrors = '';
      }
    });
  },
  methods: {
    processStripe(billingDetails) {
      let vueComponent = this;

      this.Stripe.createPaymentMethod({
        type: 'card',
        card: this.StripeCard,
        billing_details: billingDetails
      },).then((result) => {
        if (result.error) {
          vueComponent.StripeErrors = result.error.message;
        } else {
          vueComponent.StripeErrors = '';

          let paymentData = {
            paymentMethodId: result.paymentMethod.id,
          };

          this.$emit('stripeProcessed', paymentData);

          vueComponent.StripeCard.clear();
        }
      });
    },
    processStripePromise(billingDetails) {
      let vm = this;

      return new Promise((resolve, reject) => {
        this.Stripe.createPaymentMethod({
          type: 'card',
          card: this.StripeCard,
          billing_details: billingDetails
        }).then((result) => {
          if (result.error) {
            vm.StripeErrors = result.error.message;
            reject();
          } else {
            vm.StripeErrors = '';

            let paymentData = {
              paymentMethodId: result.paymentMethod.id,
            };

            resolve(paymentData);
          }
        });
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.card_input {
  width: 100%;
  padding: 9px 6px;
  border: 1px solid $border;
}

.card-errors {
  padding-top: 0;
}
</style>
